/* eslint-disable i18next/no-literal-string -- css not user facing text */
import { defineSlotRecipe } from '@chakra-ui/react';

export const numberInput = defineSlotRecipe({
  className: 'chakra-number-input',
  slots: ['root', 'base', 'input', 'control', 'incrementTrigger', 'decrementTrigger', 'valueText'],

  variants: {
    size: {
      xs: {
        input: {
          borderRadius: 'md',
          fontSize: 'xs',
        },
      },
      sm: {
        input: {
          borderRadius: 'md',
          fontSize: 'sm',
        },
      },
      md: {
        input: {
          borderRadius: 'md',
          fontSize: 'sm',
        },
      },
    },

    variant: {
      outline: {
        input: {
          bg: 'transparent',
          borderWidth: '1px',
          borderColor: 'gray.400',
          focusVisibleRing: 'inside',
          paddingInline: 4,
          _hover: {
            borderColor: 'blue.300',
          },
          _focusVisible: {
            borderColor: 'blue.500',
            boxShadow: `0 0 0 1px var(--chakra-colors-blue-focus-ring)`, // blue.50
          },
          _disabled: {
            bg: 'gray.100',
            borderColor: 'on-navy.200',
            opacity: 0.4,
            _hover: {
              // Disable hover state for disabled
              borderColor: 'on-navy.200',
            },
          },
          _placeholder: {
            // Defaults to 0.6 - setting to 1 so we can explicitly set the colour we want
            opacity: 1,
          },
        },
      },
    },
  },
});
